import React from 'react';
import { withTheme } from 'styled-components';

export const CheckboxIcons = {
  Active: withTheme(({ theme, size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" transform="translate(2 2)">
        <rect
          width="19"
          height="19"
          x=".5"
          y=".5"
          fill={theme.colors.common.form.checkbox.background}
          stroke={theme.colors.common.form.checkbox.stroke}
          strokeWidth={2}
          rx="4"
        />
        <path
          fill={theme.colors.common.form.checkbox.active}
          d="M8 15.42l-5-5 1.41-1.41L8 12.59 15.59 5 17 6.42z"
        />
      </g>
    </svg>
  )),
  Inactive: withTheme(({ theme, size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <rect
        width="19"
        height="19"
        x=".5"
        y=".5"
        fill={theme.colors.common.form.checkbox.background}
        stroke={theme.colors.common.form.checkbox.stroke}
        strokeWidth={2}
        rx="4"
        transform="translate(2 2)"
      />
    </svg>
  )),
};

export const RadioIcons = {
  Unchecked: withTheme(({ theme, size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        fill={theme.colors.common.form.radio.background}
        stroke={theme.colors.common.form.radio.stroke}
        fillRule="nonzero"
        strokeWidth="2"
      />
    </svg>
  )),
  Checked: withTheme(({ theme, size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="nonzero">
        <circle
          cx="12"
          cy="12"
          r="11"
          fill={theme.colors.common.form.radio.background}
          stroke={theme.colors.common.form.radio.stroke}
          strokeWidth="2"
        />
        <circle
          cx="12"
          cy="12"
          r="7"
          fill={theme.colors.common.form.radio.checked}
        />
      </g>
    </svg>
  )),
};
